import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Modal from "../component/Modal";
import Services from "../component/Services";
import CountUp from "./CountUp";
import HowItWorks from "../component/HowItWorks";
import HeroComponent from "../component/HeroComponent";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
// localStorage.removeItem("modalShown");

const Home = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    const hasModalShown = localStorage.getItem("modalShown");
    if (!hasModalShown) {
      setModalOpen(true);
      localStorage.setItem("modalShown", "true");
    }
  }, []);

  return (
    <>
      <Modal isOpen={modalOpen} onClose={closeModal} />
      <HeroComponent />
      <Container>
        <Services />
        <StatsSection>
          <Title>Statistics From Last Month</Title>
          <StatsWrapper>
            <StatCard>
              <StatNumber>
                <CountUp from={0} to={50} duration={1} />+
              </StatNumber>
              <StatLabel>Appointments Released</StatLabel>
            </StatCard>
            <Divider />
            <StatCard>
              <StatNumber>
                <CountUp from={0} to={87} duration={1} />+
              </StatNumber>
              <StatLabel>Applications Processing</StatLabel>
            </StatCard>
            <Divider />
            <StatCard>
              <StatNumber>
                <CountUp from={0} to={1160} duration={1} />+
              </StatNumber>
              <StatLabel>Passports Completed</StatLabel>
            </StatCard>
          </StatsWrapper>
        </StatsSection>

        <HowItWorks />
      </Container>
    </>
  );
};

export default Home;

// Styled Components
const Container = styled.div`
  padding: 20px;
  max-width: 1300px;
  margin: 0 auto;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
`;

const StatsSection = styled.section`
  margin-top: 0px;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  border: 1px solid #353535;
  padding: 40px 20px;
  text-align: center;
  margin-top: 100px;
  margin-bottom: 50px;
  transition: 0.3s ease;
  &:hover {
    border: 1px solid #646464;
    border-radius: 12px;
  }
`;

const Title = styled.h2`
  color: #e6e6e6;
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 40px;
`;

const StatsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const StatCard = styled.div`
  text-align: center;
  flex: 1;
  min-width: 200px;
`;

const StatNumber = styled.div`
  font-size: 3rem;
  font-weight: bold;
  /* color: #194bfd; */

  background: linear-gradient(to right, #194bfd, #ad13fb);
  /* background: linear-gradient(to right, #3f51ff, #6f41ff); */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`;

const StatLabel = styled.div`
  font-size: 0.9rem;

  margin-top: 8px;
  color: #e6e6e6;
`;

const Divider = styled.div`
  width: 1px;
  height: 100px;
  border-right: 1px solid #353535;

  @media (max-width: 768px) {
    width: 60%;
    height: 1px;
  }
`;
